import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MyPlan from "@/pages/MyPlan";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/my-plan")({
  head: () => seoHead("/my-plan"),
  component: () => (
    <AuthGate><MyPlan /></AuthGate>
  ),
});
